import { Card, Grid } from "@mui/material";

import { ApiHotelItem } from "@/api/hotel";
import useThemeData from "@/hooks/useThemeData";

import HotelItemCard from "../HotelItemCard";

interface HotelListCardProps {
  data: ApiHotelItem[];
  onAlert: (data: ApiHotelItem) => void;
}
const HotelListCard = (props: HotelListCardProps) => {
  const theme = useThemeData();
  return (
    <div>
      <Grid container spacing={2} alignItems="stretch">
        {props.data.map((item, index) => {
          return (
            <Grid key={index} item xs={12} sm={6} md={6} lg={4} xl={3}>
              <Card
                style={{
                  borderColor: theme.palette.divider,
                  borderWidth: 1,
                  borderStyle: "solid",
                  background: "none",
                  borderRadius: "16px",
                  transition: "box-shadow 0.3s ease-in-out",
                  height: "100%",
                }}
                elevation={2}
                className="rounded-[6px] cursor-pointer hover:shadow-lg relative"
                sx={{
                  "&:hover": {
                    elevation: 6,
                    boxShadow: 6,
                  },
                }}
              >
                <HotelItemCard data={item} onAlert={props.onAlert} />
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default HotelListCard;
